import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import overviewAgentIdentityQuery from '@atlassian/jira-relay/src/__generated__/overview_agentIdentityQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const csmAgentOverviewEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-csm-agent" */ './src/ui/overview').then(
			(module) => module.AgentOverview,
		),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: overviewAgentIdentityQuery,
				variables: {
					helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`,
				},
			},
		},
	}),
});
